import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { CurrencyResource } from "@exonn/js-sdk";

export const module: ModuleOptions<CurrencyResource> = {
  resource: ResourceEnum.Currency,
  smallIcon: <i className="icon-15-currency" />,
  bigIcon: <i className="icon-20-currency" />,

  list: {
    hideDeleteAction: (row) => row.is_default,
  },
  tabs: {
    edit: {
      getTitle: (resource: CurrencyResource) => resource.iso,
    },
  },
};
